import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import EditTable from '../EditTable';
import { LockFill, UnlockFill } from 'react-bootstrap-icons';

class Employees extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			employees: [],
			editable: false,
			editorsOpen: [],
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadEmployees();
	}

	loadEmployees() {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/Search',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'SHOPS_EMPLOYEES_VW',
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				for (var i = 0; i < data.Data.length; i++) {
					data.Data[i].id = i;
				}
				self.mergeState({ employees: data.Data });
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
		
	onEdit(accessor, editorIsOpen, idx) {
		// adjust list of open editors in new state
		var newState = {
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			renderKey: this.state.renderKey + 1
		};

		this.mergeState(newState);
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}		

	onChange(accessor, value) {
		var newState = this.copyObject(this.state);
		this.setByAccessor(newState, accessor, value);

		// if this accessor represents an EditTable
		if (['employees'].includes(accessor)) {
			// update editor status as well
			newState.editorsOpen = this.setEditorStatus(accessor, false);
		}
		this.mergeState(newState);
	}

	onSubmit(event) {
		var self = this;

		if (this.state.editorsOpen.includes('employees')) {
			this.showAlert('Editor Open', 'Please close the employee editor before saving.');
		} else {
			var employees = this.copyObject(this.state.employees);

			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Jobtrack/UpdateEmployees',
				overlay: true,
				data: {
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					employees: {
						employees: employees
					}
				}
			}).done(function (data) {
				if (data.Success) {
					self.props.parent.showConfirmation(() => {
						return (<>
							Employees successfully updated.
						</>);
					});				
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
							Shops Employees&nbsp;&nbsp;
							{this.state.editable ? 
							  <UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }}
								onClick={() => this.mergeState({ editable: false })} /> : 
							  <LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} 
								onClick={() => this.mergeState({ editable: true })} />}
						</div>
						<div style={{ marginBottom: '10px' }}>
							Employee's info comes from the Building Access System.<br />
							If a name is not showing, please check that the person has been entered under the right unit (shops, EH&S or Building Management)
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
						  data={this.state.employees} editable={this.state.editable} tableColumns={empTableColumns} 
						  editColumns={empEditColumns} tableName='Jobtrack_Employees' 
						  onEdit={(editorIsOpen, idx) => this.onEdit('employees', editorIsOpen, idx)}
						  onChange={(data, callback) => this.onChange('employees', data)} />
					  </Col>
					</Row>
					<Row>
					  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
						{this.state.editable && <Button id="save" variant="warning" type="button" className="float-end" onClick={() => this.onSubmit()}>Save</Button>}
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const empTableColumns = [
	{ Header: 'ID', accessor: 'PERSON_ID', width: 60 },
	{ Header: 'Name', accessor: 'EMP_NAME', width: 200 },
	{ Header: 'Contact', accessor: 'EMAIL', width: 250 },
	{ Header: 'Shop', accessor: 'SHOP_NAME', width: 200 }
];

const empEditColumns = [
	{ Header: 'ID', accessor: 'PERSON_ID', row: 0, col: 0, editable: false },
	{ Header: 'Name', accessor: 'EMP_NAME', row: 0, col: 1, editable: false },
	{ Header: 'Contact', accessor: 'EMAIL', row: 1, col: 0, editable: false },
	{ Header: 'Shop', accessor: 'SHOP_ID', labelAccessor: 'SHOP_NAME', type: 'select', row: 1, col: 1, required: true,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.SHOPS', order: 'SHOP_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null'}}}
];

export default withRouter(Employees);
